"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _reactToString = _interopRequireDefault(require("react-to-string"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _debounce = _interopRequireDefault(require("../utils/debounce"));
var _useResizeObserver = _interopRequireDefault(require("../utils/useResizeObserver"));
var _StyleConfig = require("../utils/StyleConfig");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _TextConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-concur_android.css") : void 0);
var _TextConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-concur_default.css") : void 0);
var _TextConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-concur_gateway.css") : void 0);
var _TextConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-concur_ios.css") : void 0);
var _TextSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-sap_fiori_3_dark.css") : void 0);
var _TextSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-sap_fiori_3_hcb.css") : void 0);
var _TextSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-sap_fiori_3_hcw.css") : void 0);
var _TextSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-sap_fiori_3.css") : void 0);
var _TextSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-sap_horizon_dark.css") : void 0);
var _TextSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-sap_horizon_hcb.css") : void 0);
var _TextSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-sap_horizon_hcw.css") : void 0);
var _TextSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Text-sap_horizon.css") : void 0);
var _excluded = ["allowHyphenation", "children", "className", "classNameMap", "expanded", "id", "maxLines", "showMore", "tag"];
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var styles = {
  concur_android: _TextConcur_android.default,
  concur_default: _TextConcur_default.default,
  concur_gateway: _TextConcur_gateway.default,
  concur_ios: _TextConcur_ios.default,
  sap_fiori_3_dark: _TextSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _TextSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _TextSap_fiori_3_hcw.default,
  sap_fiori_3: _TextSap_fiori_.default,
  sap_horizon_dark: _TextSap_horizon_dark.default,
  sap_horizon_hcb: _TextSap_horizon_hcb.default,
  sap_horizon_hcw: _TextSap_horizon_hcw.default,
  sap_horizon: _TextSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-text';

/**
 * The **Text** component can be used for embedding long
 * text, that needs themed styles
 * and formatting and/or truncation,
 * into your application.
 */

var Text = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classnames;
  var allowHyphenation = props.allowHyphenation,
    children = props.children,
    className = props.className,
    classNameMap = props.classNameMap,
    expanded = props.expanded,
    id = props.id,
    maxLines = props.maxLines,
    showMore = props.showMore,
    tag = props.tag,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(typeof maxLines === 'number' && maxLines > 0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hasMaxLines = _useState2[0],
    setHasMaxLines = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isClamped = _useState4[0],
    setIsClamped = _useState4[1];
  var _useState5 = (0, _react.useState)(expanded),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isExpanded = _useState6[0],
    setIsExpanded = _useState6[1];
  var classnames = _bind.default.bind(classNameMap);
  var textRef = (0, _react.useRef)(null);
  var mergedRef = (0, _reactMergeRefs.default)([ref, textRef]);
  var textId = (0, _useUniqueId.default)();
  var _ref = showMore || {},
    showMoreLabel = _ref.showMoreLabel,
    showLessLabel = _ref.showLessLabel,
    onShowMoreClick = _ref.onClick,
    buttonProps = _ref.buttonProps,
    containerProps = _ref.containerProps;
  var updateClamping = function updateClamping() {
    var _ref2 = textRef.current || {},
      offsetHeight = _ref2.offsetHeight,
      scrollHeight = _ref2.scrollHeight;
    var newIsClamping = scrollHeight > offsetHeight;
    setIsClamped(newIsClamping);
  };
  var onResize = (0, _debounce.default)(function () {
    if (isExpanded) return;
    updateClamping();
  });
  (0, _useResizeObserver.default)({
    targetRef: textRef,
    onResize: onResize
  });
  (0, _react.useEffect)(function () {
    if (!isExpanded) {
      updateClamping();
    }
  }, [isExpanded]);
  (0, _react.useEffect)(function () {
    var newValue = typeof maxLines === 'number' && maxLines > 0;
    setHasMaxLines(newValue);
  }, [maxLines]);
  var maxLineStyle;
  if (hasMaxLines && !isExpanded) {
    maxLineStyle = {
      WebkitLineClamp: "".concat(parseInt(maxLines, 10))
    };
  }
  var handleShowMoreClick = function handleShowMoreClick() {
    var newIsExpanded = !isExpanded;
    setIsExpanded(newIsExpanded);
    onShowMoreClick === null || onShowMoreClick === void 0 || onShowMoreClick(newIsExpanded);
  };
  var classes = classnames(className, CSS_BLOCK, (_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--max-lines"), hasMaxLines), (0, _defineProperty2.default)(_classnames, "".concat(CSS_BLOCK, "--hyphenation"), allowHyphenation), _classnames));
  var containerClasses = classnames("".concat(CSS_BLOCK, "__container"), containerProps === null || containerProps === void 0 ? void 0 : containerProps.className);
  var ElementToRender = _StyleConfig.TEXT_TAGS.indexOf(tag) !== -1 ? tag : 'span';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ElementToRender, (0, _extends2.default)({
    title: isClamped && !isExpanded ? (0, _reactToString.default)(children) : undefined
  }, otherProps, {
    id: hasMaxLines && showMore && !id ? textId : id,
    ref: mergedRef,
    className: classes,
    style: _objectSpread(_objectSpread({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.style), maxLineStyle)
  }), children), hasMaxLines && showMore && (isClamped || isExpanded) && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, containerProps, {
    className: containerClasses
  }), /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({
    compact: true,
    type: "link"
  }, buttonProps, {
    "aria-controls": !id ? textId : id,
    "aria-expanded": isExpanded,
    onClick: handleShowMoreClick
  }), isExpanded ? showLessLabel : showMoreLabel)));
});
Text.displayName = 'Text';
Text.propTypes = {
  /** String content or React.node. */
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  /** Custom classes to be added to the text's wrapper element.  */
  className: _propTypes.default.string,
  /** Set to **true** to render the full text content in the expanded state. */
  expanded: _propTypes.default.bool,
  /** The `id` attribute for the component. */
  id: _propTypes.default.string,
  /** Set to a natural number to limit the number of lines for wrapping texts.  */
  maxLines: _propTypes.default.number,
  /**
   * Defines the properties for the Show More/Show Less button when `maxLines` is used.
   * `showMoreLabel` (string): Localized text for the button when lines are
   * clamped at `maxLines`. Use `CoreUIComponents.ShowMore`.
   *
   * `showLessLabel` (string): Localized text for the button when full content is
   * being shown and no lines are clamped. Use `CoreUIComponents.ShowLess`.
   *
   * `onClick` (func): Callback for the **Button**'s click event. Will be passed a boolean
   * parameter for whether the text is fully expanded or not.
   *
   * `buttonProps` (object): Additional props to spread to the **Button** component.
   *
   * `containerProps` (object): Additional props to spread to the `<div>` element
   * wrapping the **Button** component.
   */
  showMore: _propTypes.default.shape({
    showMoreLabel: _CustomPropTypes.default.localizedString('CoreUIComponents.ShowMore').isRequired,
    showLessLabel: _CustomPropTypes.default.localizedString('CoreUIComponents.ShowLess').isRequired,
    onClick: _propTypes.default.func,
    buttonProps: _propTypes.default.object,
    containerProps: _propTypes.default.object
  }),
  /** Choose the HTML tag to use when rendering this block of text.
   * One of:
   *
   * * `'b'`
   * * `'em'`
   * * `'span'`
   * * `'p'`
   * * `'i'`
   * * `'pre'`
   * * `'strong'`
   * * `'code'`
   * * `'div'`
    */
  tag: _propTypes.default.oneOf(_StyleConfig.TEXT_TAGS),
  /** Set to a **true** to allow hyphenating wrapped text.  */
  allowHyphenation: _propTypes.default.bool
};
Text.defaultProps = {
  tag: 'span'
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(Text);
exports.default = _default;